/**
 * App icon: a handwritten "e" drawn as an off-white ribbon on a clay tile. Where the stroke passes under itself it
 * shades toward the clay. Generated by design/engram-icon-build.py from design/engram-icon-final.json.
 */
const RUNS: [string, string][] = [
  ["#f8eee8", "122,415 127,414"],
  ["#f6e8e0", "127,414 133,412 139,410"],
  ["#f4e2d9", "139,410 144,408 150,406"],
  ["#f2dcd2", "150,406 155,404 160,402"],
  ["#f0d6cb", "160,402 166,399 171,397"],
  ["#eed0c3", "171,397 176,394"],
  ["#eccabc", "176,394 181,391 186,388"],
  ["#eac4b5", "186,388 191,385 196,381"],
  ["#e8beae", "196,381 200,378 205,375"],
  ["#e6b8a6", "205,375 210,371 214,367 219,364 223,360 228,356 232,352 236,348 240,344"],
  ["#e8beae", "240,344 244,340 248,335"],
  ["#eac4b5", "248,335 252,331 256,326"],
  ["#eccabc", "256,326 260,322 263,317"],
  ["#eed0c3", "263,317 267,313"],
  ["#f0d6cb", "267,313 270,308 273,303"],
  ["#f2dcd2", "273,303 277,298 280,293"],
  ["#f4e2d9", "280,293 283,289 286,283"],
  ["#f6e8e0", "286,283 289,278 292,273"],
  ["#f8eee8", "292,273 294,268 297,263 299,257"],
  ["#faf4ef", "299,257 301,252 304,247 306,241 307,236 309,230 311,224"],
  ["#fcfaf6", "311,224 312,219 314,213 315,207 316,202 316,196 317,190 317,184 317,178 317,173 317,167 316,161 315,155 314,149 313,144 311,138 308,133 305,128 302,123 298,119 293,115 289,112 283,109 278,107 272,106 266,105 261,105 255,106 249,107 244,109 238,112 234,115 229,119 225,123 221,127 217,132 214,137 211,142 209,147 207,153 205,158 203,164 202,169 201,175 200,181 199,187 198,192 197,198 196,204 196,210 196,216 195,221 195,227 195,233 195,239 196,245 196,251 196,256 197,262 198,268 198,274 199,280 200,285 201,291 202,297 204,302 205,308 207,314 208,319 210,325 212,330 214,336 217,341 219,347 222,352 224,357 227,362 230,367 234,372 237,376 241,381 245,385 249,389 254,393 259,396 264,399 269,401 275,403 280,405 286,406 292,407 298,407 303,407 309,406 315,405 321,404 326,402 332,400 337,398"],
  ["#faf4ef", "337,398 342,396 347,393"],
  ["#f8eee8", "347,393 352,390"],
  ["#f6e8e0", "352,390 357,387 362,383"],
  ["#f4e2d9", "362,383 367,379"],
  ["#f2dcd2", "367,379 371,376"],
  ["#f0d6cb", "371,376 375,372"],
  ["#eed0c3", "375,372 379,367"],
  ["#eccabc", "379,367 383,363"],
  ["#eac4b5", "383,363 387,359"],
  ["#e8beae", "387,359 389,356"],
];

export function Icon({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true">
      <defs>
        <linearGradient id="eg-g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#e2805f" /><stop offset="1" stopColor="#cc6a48" /></linearGradient>
      </defs>
      <rect width="512" height="512" rx="114" fill="url(#eg-g)" />
      <g fill="none" strokeWidth="42" strokeLinecap="round" strokeLinejoin="round">
        {RUNS.map(([color, points], i) => (
          <polyline key={i} points={points} stroke={color} />
        ))}
      </g>
    </svg>
  );
}

/** Lockup: icon + lowercase Fraunces italic wordmark. */
export function Logo({ size = 20 }: { size?: number }) {
  return (
    <span className="logo" style={{ fontSize: size }}>
      <Icon size={Math.round(size * 1.05)} />
      <span className="wordmark">engram</span>
    </span>
  );
}
